import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { callcenterService } from '../../api/callcenterService';
import { Card, CardHeader, CardTitle, CardContent, CardFooter, Button, Input, Label } from '../ui';
import toast from 'react-hot-toast';

const UserCreate = () => {
  const [extension, setExtension] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!extension || !password) {
      toast.error('Extension and password are required');
      return;
    }
    setSubmitting(true);
    try {
      await callcenterService.createUser({ extension, password });
      toast.success('User created');
      navigate('/callcenter/users');
    } catch (e) {
      console.error(e);
      toast.error(e?.response?.data || 'Create failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Create Call Center User</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="ext">Extension</Label>
              <Input
                id="ext"
                placeholder="e.g., 1001"
                value={extension}
                onChange={(e) => setExtension(e.target.value)}
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="pwd">Password</Label>
              <Input
                id="pwd"
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <CardFooter className="px-0">
              <div className="flex items-center gap-3">
                <Button type="submit" disabled={submitting}>
                  {submitting ? 'Creating...' : 'Create'}
                </Button>
                <Button variant="secondary" type="button" onClick={() => navigate('/callcenter/users')}>
                  Cancel
                </Button>
              </div>
            </CardFooter>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default UserCreate;

